<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Badges' : 'Deleted Badges'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/badges/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search badges..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="type"
                    solo
                    rounded
                    v-model="filter.type"
                    :items="types"
                    clearable
                    @click:clear="(filter.type = null), (page = 1)"
                    label="Type"
                    @input="getData"
                    prepend-inner-icon="mdi-view-grid"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="validity_type"
                    solo
                    rounded
                    v-model="filter.validity_type"
                    :items="validityTypes"
                    clearable
                    @click:clear="(filter.validity_type = null), (page = 1)"
                    label="Validity Type"
                    @input="getData"
                    prepend-inner-icon="mdi-calendar-clock"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left">ID</th>
                      <th class="text-left">Icon</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Type</th>
                      <th class="text-left">Validity Type</th>
                      <th class="text-left">Validity Value</th>
                      <th class="text-left">Created At</th>
                      <th class="text-left">Updated At</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="badges.length != 0">
                    <tr
                      v-for="(badge, i) in badges"
                      :key="`badge_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': badges.length - 1 == i,
                      }"
                    >
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>{{ badge.id }}</td>
                      <td>
                        <v-img
                          v-if="badge.icon_url"
                          :src="`${mediaUrl}${badge.icon_url}`"
                          height="40"
                          width="40"
                          contain
                        ></v-img>
                        <span v-else>-</span>
                      </td>
                      <td>{{ badge.name || "" }}</td>
                      <td>
                        <v-tooltip bottom v-if="badge.type">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              small
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              @click="showBadgesOfType(badge.type)"
                              style="cursor: pointer"
                            >
                              {{ badge.type }}
                              <v-icon right small>mdi-information</v-icon>
                            </v-chip>
                          </template>
                          <span>Click to view all {{ badge.type }} badges</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-chip small outlined v-if="badge.validity_type">
                          {{ badge.validity_type }}
                        </v-chip>
                      </td>
                      <td>{{ badge.validity_value || "-" }}</td>
                      <td>{{ formatDate(badge.created_at) }}</td>
                      <td>{{ formatDate(badge.updated_at) }}</td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(badge.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Badge</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/badges/${encryptIt(badge.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Badge</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(badge.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this Badge</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="10" class="text-center">No badges found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Success Dialog -->
      <v-dialog v-model="is_deleted_badge" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Success!</h1>
                      <br />
                      <h3>Badge deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_badge = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Badges by Type Dialog -->
      <v-dialog v-model="showTypeDialog" width="800" scrollable>
        <v-card rounded="xxl">
          <v-card-title class="primary white--text">
            <v-icon color="white" class="mr-2">mdi-view-grid</v-icon>
            All "{{ selectedType }}" Badges ({{ badgesOfSelectedType.length }})
            <v-spacer></v-spacer>
            <v-btn icon dark @click="showTypeDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4">
            <v-row v-if="loadingTypeDialog">
              <v-col class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                sm="6"
                md="4"
                v-for="badge in badgesOfSelectedType"
                :key="badge.id"
              >
                <v-card outlined hover>
                  <v-card-text>
                    <div class="text-center mb-2">
                      <v-img
                        v-if="badge.icon_url"
                        :src="`${mediaUrl}${badge.icon_url}`"
                        height="60"
                        width="60"
                        contain
                        class="mx-auto"
                      ></v-img>
                      <v-icon v-else size="60" color="grey"
                        >mdi-badge-account</v-icon
                      >
                    </div>
                    <h4 class="text-center">{{ badge.name }}</h4>
                    <p class="caption text-center mb-2">
                      {{ badge.description }}
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <div class="caption">
                      <div>
                        <strong>Validity:</strong> {{ badge.validity_type }}
                        <span v-if="badge.validity_value"
                          >({{ badge.validity_value }})</span
                        >
                      </div>
                      <div>
                        <strong>ID:</strong> {{ badge.id }}
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      x-small
                      color="primary"
                      :to="`/badges/${encryptIt(badge.id)}`"
                    >
                      <v-icon small left>mdi-pencil</v-icon>
                      Edit
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "BadgesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: null,
        type: null,
        validity_type: null,
      },
      badges: [],
      statuses: [
        { text: "ACTIVE", value: "1" },
        { text: "INACTIVE", value: "0" },
      ],
      types: [
        { text: "Achievement", value: "achievement" },
        { text: "Activity", value: "activity" },
        { text: "Honor", value: "honor" },
      ],
      validityTypes: [
        { text: "Permanent", value: "permanent" },
        { text: "Days", value: "days" },
        { text: "Months", value: "months" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelloading: false,
      is_deleted_badge: false,
      showTypeDialog: false,
      selectedType: "",
      badgesOfSelectedType: [],
      loadingTypeDialog: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword || "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&is_active=" +
        (this.filter.is_active || "") +
        "&type=" +
        (this.filter.type || "") +
        "&validity_type=" +
        (this.filter.validity_type || "");

      await axios
        .get(`badges?${query}`)
        .then((response) => {
          this.badges = response.data.data;
          console.log("badges", this.badges);
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },

    async generateExcel() {
      this.isExcelloading = true;
      let query =
        "search_keyword=" +
        this.filter.search_keyword +
        "&is_active=" +
        (this.filter.is_active || "") +
        "&type=" +
        (this.filter.type || "") +
        "&validity_type=" +
        (this.filter.validity_type || "");
      let response = await axios.get(`badge_exports?${query}`);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
      this.isExcelloading = false;
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },

    async Delete_this(id) {
      await axios
        .post(`/badges/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_badge = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async Restore_this(id) {
      await axios
        .post(`/badges/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async showBadgesOfType(type) {
      this.selectedType = type;
      this.showTypeDialog = true;
      this.loadingTypeDialog = true;
      try {
        let response = await axios.get(`/badges?type=${type}&rowsPerPage=100`);
        this.badgesOfSelectedType = response.data.data || [];
      } catch (error) {
        console.log("Error loading badges by type:", error);
        this.badgesOfSelectedType = [];
      }
      this.loadingTypeDialog = false;
    },
  },
};
</script>
